var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultMonochromeLivingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "iconLeft",
    "data-v-423bf9ae": "",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "data-v-423bf9ae": ""
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    "data-v-423bf9ae": "",
    gradientTransform: "rotate(25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41e296",
    "data-v-423bf9ae": "",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00c4ee",
    "data-v-423bf9ae": "",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.776,
    x2: 29.78,
    y1: 15.381,
    y2: 15.381,
    gradientTransform: "scale(1.0745 .93063)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 17.366,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 32,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.8125)",
    "data-v-423bf9ae": ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.579 32h20.421l-10.211-17.686z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.683,
    cy: 8.683,
    r: 8.683,
    fill: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMonochromeLivingLogo);
export default __webpack_public_path__ + "static/media/default-monochrome_living_logo.4975c6bd962e8819414303ead969466a.svg";
export { ForwardRef as ReactComponent };